import { capitalizeString, formatPhone } from '@/utils/index';
import { SerializeVehicleReport } from './vehicleReportSerializer';
import { reportTypes, serializedTypes } from '../types';
import {
  AutomobileAccident,
  AutomobileTheft,
  AutomobileRepairQuote,
  StateContact,
} from '../types/vehicles';

type VehicleReportSerializer = (
  rawReport: reportTypes.Report
) => serializedTypes.SerializedVehicleReport;

export class VehicleReport {
  public data: serializedTypes.SerializedVehicleReport;

  constructor(
    rawData: reportTypes.Report,
    serializer: VehicleReportSerializer = SerializeVehicleReport
  ) {
    this.data = serializer(rawData);
  }
}

export function generateSectionSourceData(
  section: AutomobileAccident | AutomobileTheft
) {
  const accidentSource = section.source;
  const parsedLocation = accidentSource?.contact?.addresses[0]?.parsed;
  const locationString = parsedLocation
    ? `${parsedLocation.city}, ${parsedLocation.state} ${parsedLocation.zip5}`
    : '';

  return [
    ['Name', capitalizeString(accidentSource?.name || '')],
    ['Website', capitalizeString(accidentSource?.website || '')],
    [
      'Phone',
      accidentSource?.contact?.phones[0]?.number
        ? formatPhone(accidentSource?.contact?.phones[0].number)
        : '',
    ],
    ['Email', accidentSource?.contact?.emails[0]?.address || ''],
    ['Source', accidentSource?.source || ''],
    ['Location', locationString],
  ].filter(([, value]) => Boolean(value));
}

export function generateSectionIdentifyingData(
  section: AutomobileAccident | AutomobileTheft | AutomobileRepairQuote
) {
  return [
    ['Vehicle make', section?.vehicle?.make?.toUpperCase() || ''],
    ['Vehicle model', section?.vehicle?.model?.toUpperCase() || ''],
    [
      'Vehicle year',
      section?.vehicle?.year ? section?.vehicle?.year?.toString() : '',
    ],
    ['Vehicle style', capitalizeString(section?.vehicle?.style || '')],
    ['Vehicle type', capitalizeString(section?.vehicle?.type || '')],
    ['Vehicle color', section?.vehicle?.color || ''],
  ].filter(([, value]) => Boolean(value));
}

export function handleClickStateContact(
  code: string | undefined,
  statesContact: StateContact[],
  setStateSelected: React.Dispatch<
    React.SetStateAction<StateContact | undefined>
  >,
  handleCloseState: () => void
) {
  if (code) {
    const state = statesContact.find(
      (state: StateContact) => state.code === code
    );
    setStateSelected(state);
  }

  handleCloseState();
}
